/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { featureLandingConfig } from '../../config/featuresSection.config';
import { footerLandingConfig } from '../../config/footer.config';
import { headerLandingConfig } from '../../config/header.config';
import { heroSectionLandingConfig } from '../../config/heroSection.config';
import { imageFeatureLandingConfig } from '../../config/imageFeatureSection.config';
import { mainSectionLandingConfig } from '../../config/mainSection.config';
import { howItWorksLandingConfig } from '../../config/how-it-work.config';

export interface ILandingPageDataMethods extends IPluginMethodMap {
  getLandingPageData(): Promise<any>;
}

export class LandingPageDataService implements IAgentPlugin {
  readonly methods: ILandingPageDataMethods;

  constructor() {
    this.methods = {
      getLandingPageData: this.getProps.bind(this),
    };
  }

  async getProps() {
    return {
      ...(headerLandingConfig || {}),
      ...(heroSectionLandingConfig || {}),
      ...(howItWorksLandingConfig || {}),
      ...(mainSectionLandingConfig || {}),
      ...(featureLandingConfig || {}),
      ...(imageFeatureLandingConfig || {}),
      ...(footerLandingConfig || {}),
    };
  }
}
